import {
  createRouter,
  createWebHistory,
  type RouteLocationNormalizedGeneric,
  type RouteRecordRaw,
} from 'vue-router';
import { CommonEntryPoint, CommonNotFound } from '@/core/components/common';
import bus from '@/plugins/bus';
import { useUser } from '@/modules/auth/store/user.store.ts';
import { useAppStore } from '@/core/stores/useAppStore';

const loadRouter = async () => {
  const routes: Array<RouteRecordRaw> = [];
  const modules = import.meta.glob('/**/*.route.ts');

  for (const path in modules) {
    const module: any = await modules[path]!();
    routes.push(...module.default);
  }

  const routesArray = [
    // Entry Point
    {
      name: 'root',
      path: '/',
      component: CommonEntryPoint,
    },
    {
      name: 'home',
      path: '/home',
      redirect: { name: 'allrecruitment' },
    },

    // Auto register routes
    ...routes,

    // Not Found
    {
      path: '/:catchAll(.*)',
      component: CommonNotFound,
    },
  ];

  const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: routesArray,
  });

  router.beforeEach(async (to, from) => {
    if (to.path !== from.path) bus.emit('loading_app', true);

    if (to.meta.requiresAuth) {
      const user = useUser();
      const ok = await user.isAuthenticated();
      if (!ok) {
        bus.emit('redirectLogin');
        return false;
      }
    }
  });

  router.afterEach((to, from) => {
    if (to.path !== from.path) bus.emit('loading_app', false);
  });

  router.afterEach((to: RouteLocationNormalizedGeneric) => {
    const appStore = useAppStore();
    if (to.meta.title) {
      appStore.setTitle(to.meta.title);
    }
  });

  return router;
};

export default loadRouter;
